import { useConfigStore } from '@/stores';
import styles from './styles.module.scss';
import { useShopStore } from '@/stores';
import ShopFnbFacilityCategoryButton from '@/components/common/shop-fnb-facility/buttons/category';
import { useShopCategories } from '@/hooks/poi/useShopData';
import type { BuildingCategory } from '@/services/dto';
import { useTranslation } from 'react-i18next';
import { SHOP_SEARCH_MODE } from '@/enums/shop';
import { useOrientation } from '@/hooks';
import clsx from 'clsx';

interface ShopSearchByCategoryProps {
    onSelectCategory?: (category: BuildingCategory) => void;
}

const ShopSearchByCategory = ({ onSelectCategory }: ShopSearchByCategoryProps) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const { isHorizontal } = useOrientation();
    const { t } = useTranslation();
    const selectedBuildingId = useShopStore((state) => state.selectedBuildingId);
    const selectedCategory = useShopStore((state) => state.selectedCategory);
    const setSelectedCategory = useShopStore((state) => state.setSelectedCategory);
    const updateShopContents = useShopStore((state) => state.updateShopContents);
    const shop = useShopCategories(selectedBuildingId || 'all');

    const handleSelectCategory = (category: BuildingCategory) => {
        setSelectedCategory(category);
        onSelectCategory?.(category);
        updateShopContents(SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY);
    };

    return (
        <div
            data-region-name="shop-search-by-category"
            className={clsx(styles['shop-search-by-category'], {
                [styles['shop-search-by-category--vertical']]: !isHorizontal,
            })}
            data-region-nav
        >
            {shop.map((category) => (
                <ShopFnbFacilityCategoryButton
                    tabIndex={9}
                    data-interactive
                    role="radio"
                    type="button"
                    aria-checked={selectedCategory?.clientCode === category.clientCode}
                    aria-label={category.clientCode === 'all' ? t(category.name[language]) : category.name[language]}
                    key={category.clientCode}
                    onClick={() => handleSelectCategory(category)}
                    title={category.clientCode === 'all' ? t(category.name[language]) : category.name[language]}
                />
            ))}
        </div>
    );
};

export default ShopSearchByCategory;
